export enum BurnsConstants {
  SET_SELECTED_BURN_TYPE = 'Burns/SET_SELECTED_BURN_TYPE',
  SET_BURNS_EXAM = 'Burns/SET_BURNS_EXAM',
  SET_BODY_AREA_CALCULATION = 'Burns/SET_BODY_AREA_CALCULATION',
  SET_BODY_VIEW = 'Burns/SET_BODY_VIEW',
  SET_TOTAL_BURNS_CALCULATIONS = 'Burns/SET_TOTAL_BURNS_CALCULATIONS',
  SET_BURN_TYPE = 'Burns/SET_BURN_TYPE',
  SET_SINGED_NASAL_HAIR = 'Burns/SET_SINGED_NASAL_HAIR',
  SET_CARBON_IN_MOUTH = 'Burns/SET_CARBON_IN_MOUTH',
  SET_POOR_VENTILATION = 'Burns/SET_POOR_VENTILATION',
  SET_CO_LEVEL = 'Burns/SET_CO_LEVEL',
  SET_CURRENT_SELECTED_OBJ = 'Burns/SET_CURRENT_SELECTED_OBJ',
  SET_RANGE = 'Burns/SET_RANGE',
  SAVE_BURNS = 'Burns/SAVE_BURNS',
  SET_BURNS = 'Burns/SET_BURNS',
  RESET_BURNS = 'Burns/RESET_BURNS',
  RESET_BURNS_TBSA = 'Burns/RESET_BURNS_TBSA',
  SET_COLOR_STATE = 'Burns/SET_COLOR_STATE',
}
